import { render, staticRenderFns } from "./TransferInspections.vue?vue&type=template&id=5f4b43fb&scoped=true&"
import script from "./TransferInspections.vue?vue&type=script&lang=ts&"
export * from "./TransferInspections.vue?vue&type=script&lang=ts&"
import style0 from "./TransferInspections.vue?vue&type=style&index=0&id=5f4b43fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4b43fb",
  null
  
)

export default component.exports